import { render, staticRenderFns } from "./WorkFloContent.vue?vue&type=template&id=4589a239&"
import script from "./WorkFloContent.vue?vue&type=script&lang=js&"
export * from "./WorkFloContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports